import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { message } from "antd";
import GenericFileViewer from "../generic-pdf-word-viewer";
import { CandidateHeaderCard, CandidateHeaderLeft, ProfileImage, CandidateName, DescriptionRow, Description, HeaderContent, ScoreValue, DesktopScoreWrapper, MobileScoreCard, ViewResumeButton, ScoreLabel, } from "./style";
const getProfileImageUrl = (url) => {
    if (url == null || typeof url !== "string")
        return undefined;
    const trimmed = url.trim();
    if (!trimmed)
        return undefined;
    const lower = trimmed.toLowerCase();
    if (lower === "null" || lower === "undefined" || lower === "none") {
        return undefined;
    }
    return trimmed;
};
export const FeedbackFormHeader = ({ candidateName, resumeLink, profileImage, score, maxScore, onResumeView, isReadOnly = false, showScore = true, }) => {
    const [isFileViewerOpen, setIsFileViewerOpen] = useState(false);
    const [fileViewerUrl, setFileViewerUrl] = useState(null);
    const [fileViewerTitle, setFileViewerTitle] = useState("Document");
    const profileSrc = getProfileImageUrl(profileImage);
    const [imageFailed, setImageFailed] = useState(false);
    useEffect(() => {
        setImageFailed(false);
    }, [profileSrc]);
    const showAvatar = profileSrc != null && !imageFailed;
    const openFileViewer = (fileUrl, title) => {
        if (!fileUrl) {
            message.error("File URL is not available.");
            return;
        }
        setFileViewerUrl(fileUrl);
        setFileViewerTitle(title || candidateName || "Document");
        setIsFileViewerOpen(true);
    };
    const handleResumeView = () => {
        if (resumeLink) {
            openFileViewer(resumeLink, candidateName);
            return;
        }
        onResumeView === null || onResumeView === void 0 ? void 0 : onResumeView();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(CandidateHeaderCard, { children: [_jsxs(CandidateHeaderLeft, Object.assign({ "$hasAvatar": showAvatar }, { children: [showAvatar && profileSrc && (_jsx(ProfileImage, { src: profileSrc, alt: candidateName || "Candidate profile photo", onError: () => setImageFailed(true) }, profileSrc)), _jsxs(HeaderContent, { children: [_jsx(CandidateName, { children: candidateName }), _jsxs(DescriptionRow, { children: [_jsx(Description, { children: !showScore
                                                    ? isReadOnly
                                                        ? "Provided overall assessment of this candidate"
                                                        : "Provide an overall assessment of this candidate"
                                                    : isReadOnly
                                                        ? "Evaluated this candidate across key competencies"
                                                        : "Evaluate this candidate across key competencies" }), resumeLink && (_jsx(ViewResumeButton, Object.assign({ type: "default", onClick: handleResumeView }, { children: "View Resume" })))] })] })] })), showScore && (_jsx(DesktopScoreWrapper, { children: _jsxs("div", { children: [_jsx(ScoreLabel, { children: "Score: \u00A0" }), _jsxs(ScoreValue, { children: [score, " / ", maxScore] })] }) }))] }), showScore && (_jsxs(MobileScoreCard, { children: [_jsx(ScoreLabel, { children: "Score: \u00A0" }), _jsxs(ScoreValue, { children: [score, " / ", maxScore] })] })), fileViewerUrl && (_jsx(GenericFileViewer, { isModalOpen: isFileViewerOpen, setIsModalOpen: (open) => {
                    setIsFileViewerOpen(open);
                    if (!open) {
                        setFileViewerUrl(null);
                    }
                }, fileUrl: fileViewerUrl, candidateName: fileViewerTitle || candidateName || "Document", placement: "right", width: "60vw" }))] }));
};
export default FeedbackFormHeader;
